<script>
import TableList from '@/components/TableList.vue'
import * as components from './TableList/'
export default {
  extends: TableList,
  components
}
</script>
<style lang="scss">
table.sale-account {
  .column-proxy {
    width: 25%;
  }
}
</style>
